<!--自定义内容弹框
2021.3.24 姚政伟 创建-->
<template>
  <van-popup v-model="show" class="y-cus-content" :close-on-click-overlay="!closeable">
    <div class="close" v-if="!closeable"><img src="../assets/close.svg" @click="close" /></div>
    <h3 v-if="title">{{title}}</h3>
    <div class="content">
      <slot></slot>
    </div>
    <div class="btn"><y-button @click="click">{{buttonText}}</y-button></div>
  </van-popup>
</template>
<script>
import Vue from "vue";
import { Popup } from "vant";

Vue.use(Popup);
export default {
  name:'YCusContentDialog',
  data() {
    return {
      show: false,
    };
  },
  created() {
    this.show = this.value;
  },
  props: {
      value:{
          type:Boolean,
          default:false
      },
      //弹框名称
      title:{
          type:String
      },
      //按钮名称
      buttonText:{
          type:String,
          default: '确认'
      },
      //是否显示关闭图标
      closeable:{
        type:Boolean,
        default:false
      }
  },
  watch: {
    show(val) {
      this.$emit("input", val);
    },
    value(val) {
      this.show = val;
    },
  },
  methods: {
    close(e) {
      this.show = false;
      this.$emit("closeClick",e);
    },
    click(e) {
      this.$emit("buttonClick",e);
    },
  },
};
</script>
<style lang="less" scoped>
  .y-cus-content{
    width: 70%;
    overflow: initial;
    background: linear-gradient(to right, #F6E6D1, #F0DEC1);
    border-radius: 15px;
    padding: 20px 14px;
    box-sizing: border-box;
    .close{
      width: 20px;
      height: 20px;
      position: absolute;
      top:-30px;
      right: -20px;
      background-color: #fff;
      border-radius: 100%;
      >img{
        width: 26px;
        height: 26px;
        left: -3px;
        top:-2px;
        position: relative;
      }
    }
    h3{
      margin: 0 0 20px 0;
    }
    .content{
      position: relative;
      width: 100%;
      overflow: auto;
    }
    .btn{
      margin-top: 28px;
      .y-button{
        background: linear-gradient(90deg, #424242 6%, #2f2f2f 96%);
        color: #ffe0a5;
      }
    }
  }
</style>
